import React from 'react';
import EventListCard from '../../common/events/EventListCard';
import EventListRow from '../../common/events/EventListRow';
import EventNavigationMenu from './EventNavigationMenu';
import type { AssignmentsSaved } from './EventListAssignmentModal';

export function EventNavigableCard({ onAssignmentsSaved, ...props }: React.ComponentProps<typeof EventListCard> & { onAssignmentsSaved?: AssignmentsSaved }) {
  return <EventListCard {...props} navigationMenu={<EventNavigationMenu event={props.event} placement="card" onAssignmentsSaved={onAssignmentsSaved} />} />;
}

export function EventNavigableRow({ onAssignmentsSaved, ...props }: React.ComponentProps<typeof EventListRow> & { onAssignmentsSaved?: AssignmentsSaved }) {
  return <EventListRow {...props} navigationMenu={<EventNavigationMenu event={props.event} placement="row" onAssignmentsSaved={onAssignmentsSaved} />} />;
}
